(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[631],{

/***/ "3Uf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Twitter", function() { return Twitter; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Twitter = function Twitter(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 405.4"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M500 48.3c-19.3 7.7-38.6 13.5-59.8 15.4 21.2-13.5 36.7-32.8 44.4-56-19.3 11.6-42.5 21.2-65.6 25.1C399.6 13.5 374.5 0 343.6 0c-56 0-102.3 46.3-102.3 102.3 0 7.7 0 15.4 1.9 23.2-83-3.9-158.3-44.4-208.5-106.2C25 34.7 21.2 52.1 21.2 69.5c0 34.7 17.4 67.6 46.3 84.9-17.4 0-32.8-3.9-48.3-11.6v1.9c0 50.2 34.7 90.7 83 100.4-7.7 1.9-17.4 3.9-27 3.9-5.8 0-13.5 0-19.3-1.9 13.5 40.5 50.2 69.5 96.5 71.4-34.7 27-79.2 44.4-127.4 44.4-7.7 0-17.4 0-25.1-1.9 46.3 29 98.5 44.4 156.4 44.4 189.2 0 291.5-156.4 291.5-291.5v-13.5c21.3-13.5 38.7-30.9 52.2-52.1z"
  }));
};

/***/ })

}]);